import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-gallery" }

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { ref, computed, useTemplateRef } from 'vue';
import { useGalleryListeners } from '../../composables/galleryListeners';
import type { GalleryElement } from '@/interfaces/components/galleryElement';
import SelectContentAnalytics from '@/js/modules/analytics/SelectContentAnalytics';
import GalleryModalWithGrid from '@lmt-rpb-new/molecules/GalleryModalNew/GalleryModalWithGrid.vue';

export type FluxImageData = {
	small: string;
	thumb: string;
	original: string;
	preview: string;
	srcset: string;
};

type Props = {
	images: Array<FluxImageData>;
	hotelName?: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'ImageGallery',
  props: {
    images: {},
    hotelName: {}
  },
  setup(__props: any) {

const props = __props;

const actualImages = computed<GalleryElement[]>(() =>
	props.images.map((image, index) => ({
		content: image.original,
		preview: image.preview,
		type: 'image',
		copyright: `© GIATA GmbH 1996 - ${new Date().getFullYear()}`,
		alt: `Image ${index + 1} of ${props.hotelName}`,
	}))
);

const modalIndex = ref(0);
const gridModalRef = useTemplateRef('gridModalRef');

const handleButtonClick = () => {
	SelectContentAnalytics.selectContent({ cId: 'hotel_gallery_button' });
	openGallery(0);
};

const handleImageClick = (index: number) => {
	SelectContentAnalytics.selectContent({ cId: 'hotel_gallery_item', index: index + 1 });
	openGallery(index);
};

const openGallery = (index: number) => {
	modalIndex.value = index;
	if (gridModalRef.value) {
		gridModalRef.value.openGalleryGridModal();
	}
};

useGalleryListeners('.hotel-gallery__item', handleImageClick);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "image-gallery__button",
      onClick: handleButtonClick,
      onKeyup: _withKeys(handleButtonClick, ["enter"])
    }, [
      _createVNode(BaseIcon, {
        class: "image-gallery__icon",
        name: "gallery"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.images.length), 1 /* TEXT */)
    ], 32 /* NEED_HYDRATION */),
    _createVNode(GalleryModalWithGrid, {
      ref_key: "gridModalRef",
      ref: gridModalRef,
      "header-title": _ctx.hotelName,
      "focused-index": modalIndex.value,
      "gallery-items": actualImages.value
    }, null, 8 /* PROPS */, ["header-title", "focused-index", "gallery-items"])
  ]))
}
}

})